/**
 * Premium features list shared across trial modals and subscription management.
 */
export const PREMIUM_FEATURES_LOST = [
  'Oral Quiz Questions',
  'Giraffe Translator',
  'Needs Guesser',
  'Empy AI Tutor',
  'Echo Arena & Full Games',
  '1-on-1 Empathy Sessions',
  'Support Chat',
  '2,500 Monthly Credits',
];
